import type { AcriAnswer } from '@/components/OnboardingQuestionPage'
import OnboardingQuestionPage from '@/components/OnboardingQuestionPage'

const answers: AcriAnswer[] = [
  { title: 'pages.onboarding.companySize.1to10', value: '1-10' },
  { title: 'pages.onboarding.companySize.11to50', value: '11-50' },
  { title: 'pages.onboarding.companySize.51to200', value: '51-200' },
  { title: 'pages.onboarding.companySize.201to1000', value: '201-1000' },
  { title: 'pages.onboarding.companySize.1000plus', value: '1000+' },
]

export default function CompanySizePage() {
  return (
    <OnboardingQuestionPage
      answers={answers}
      title="pages.onboarding.companySize.title"
      layout="grid"
    />
  )
}
